export const constant = {
  Image_Width: 'Image Width',
  Image_Height: 'Image Height',
  Upload: 'Upload',
  Site: 'Select Site'
};
